import { TCreateWorkflowTemplateVersionParams } from '@commenda/types';
import { fetcher } from '@commenda/utils';
import { BASE_URL, readErrorMessage } from './helpers';

export async function createWorkflowTemplateVersion(
  data: TCreateWorkflowTemplateVersionParams
): Promise<{
  success: boolean;
  data?: { workflowTemplateVersion: { id: string } };
  /** The server's own reason, so the caller can say what went wrong instead of "it failed". */
  error?: string;
}> {
  try {
    const res = await fetcher(`${BASE_URL}/version`, {
      method: 'POST',
      body: data,
    });
    if (!res.ok)
      return {
        success: false,
        data: undefined,
        error: await readErrorMessage(res),
      };
    const responseData = (await res.json()) as {
      workflowTemplateVersion: { id: string };
    };
    return {
      success: true,
      data: responseData,
    };
  } catch (err) {
    console.error(err);
    return { success: false, data: undefined };
  }
}
